module.exports = __webpack_public_path__ + "static/ribbon-front-d64ecc843454dceb00609f9a9e060d92.png";